import { branch, renderNothing, withHandlers } from 'recompose'

import { clearPending } from 'api/actions'
import Modal from 'shared/components/Modal'
import { userSelector } from 'auth/selectors'
import { addToWaitingListPendingSelector } from 'grs/selectors'
import { addToWaitingList } from 'grs/actions'
import { withCompletionFlag } from 'shared/hoc'

import { selectedSeasonTicketSelector } from '../selectors'

const enhance = compose(
    connect(
        createStructuredSelector({
            user: userSelector,
            seasonTicket: selectedSeasonTicketSelector,
            pending: addToWaitingListPendingSelector,
        }),
        { addToWaitingList, clearPending }
    ),
    branch(
        ({ user, seasonTicket }) =>
            !user || !seasonTicket.ticket || (seasonTicket.ticket && !seasonTicket.ticket.isOnWaitingList),
        renderNothing
    ),
    withCompletionFlag('pending', 'done', 0),
    withHandlers({
        close: ({ clearPending, onClose }) => () => (clearPending(['addToWaitingList']), onClose()),
    })
)

const WaitingList = ({ done, pending, close, seasonTicket, grsId, addToWaitingList }) => {
    const isLoading = pending === true
    const error = pending instanceof Error && pending.message

    const getHeaderText = () => {
        if (error) return <T>booking.waitingList.errorTitle</T>
        if (done) return <T>booking.waitingList.successTitle</T>

        return <T>booking.waitingList.title</T>
    }

    const getChildren = () => {
        if (error) return error
        if (isLoading) return <T>booking.waitingList.inProgress</T>
        if (done) return <T>booking.waitingList.successText</T>
    }

    const getButtonAction = () => {
        if (!isLoading && (done || error)) return close

        return () => null
    }

    React.useEffect(() => {
        addToWaitingList(seasonTicket.ticket, grsId)
    }, [])

    return (
        <Modal
            header={getHeaderText()}
            buttons={[{ label: <T>booking.waitingList.close</T>, onClick: getButtonAction() }]}
            onClose={getButtonAction()}
            loading={isLoading}>
            {getChildren()}
        </Modal>
    )
}

export default enhance(WaitingList)
